/**
 * GDPR-aware analytics for Boy Katzennetz-Berater.
 * Fires only when Shopify Customer Privacy API allows analytics processing
 * (integrated with Consentmo on this store).
 *
 * Events are published via Shopify.analytics.publish for Custom Pixels,
 * and mirrored to dataLayer for GTM if configured.
 */
(() => {
  const EVENT_PREFIX = 'boy_katzennetz_berater';

  let consentApiReady = false;

  const refreshAnalyticsAllowed = () => {
    if (!consentApiReady || !window.Shopify?.customerPrivacy) return false;
    return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true;
  };

  const loadConsentApi = () =>
    new Promise((resolve) => {
      if (!window.Shopify?.loadFeatures) {
        resolve(false);
        return;
      }

      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        (error) => {
          if (error) {
            resolve(false);
            return;
          }
          consentApiReady = true;
          resolve(true);
        }
      );
    });

  const publish = (eventName, payload) => {
    if (!refreshAnalyticsAllowed()) return;

    const data = {
      ...payload,
      event_source: 'katzennetz_berater_quiz',
    };

    try {
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish(`${EVENT_PREFIX}:${eventName}`, data);
      }
    } catch (error) {
      /* analytics unavailable */
    }

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: `${EVENT_PREFIX}_${eventName}`,
        ...data,
      });
    } catch (error) {
      /* dataLayer unavailable */
    }

    // Google & YouTube app loads gtag on the storefront — send GA4 events directly.
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', `katzennetz_berater_${eventName}`, data);
      }
    } catch (error) {
      /* gtag unavailable */
    }
  };

  document.addEventListener('visitorConsentCollected', refreshAnalyticsAllowed);
  document.addEventListener('trackingConsentAccepted', refreshAnalyticsAllowed);

  window.BoyKatzennetzBeraterAnalytics = {
    init: loadConsentApi,
    track: publish,
    isAllowed: refreshAnalyticsAllowed,
  };

  loadConsentApi();
})();
